<template>
  <div class="section">
    <section class="scan-demo-row container">
      <div class="demo-content">
        <div class="demo-content-text">
          <h2 class="demo-head"> Deploy emails that are <br /> screenshot worthy!</h2>
          <div class="demo-subhead">
            Stop settling for static emails - use Netcore's platform to create dynamic, interactive emails that convert.
          </div>
          <a class="button-primary" href="https://netcorecloud.com/email/request-demo/" data-factors-click-bind="true">Let's Deploy</a> 
          <!-- <div class="demo-cta demo-cta-lg">
          </div> -->
        </div>
        <div class="demo-content-image"> 
          <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/man-with-rocket.png" alt="Get Started Now" style="max-width: 100%;"> 
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="js">
  export default {
    name: "MarketingDemoSection",
  }
</script>
<style scoped>

.scan-demo-row {
  border-radius: 10px;
  margin-top: 40px;
}

.scan-demo-row .demo-content {
  display: flex;
  justify-content: space-between;
  padding: 50px;
  color: #222222;
  background: #fff2e6;
  width: 85%;
  margin: auto;
}

.scan-demo-row .demo-content .demo-content-text {
	display: inline-flex;
	flex-direction: column;
	flex-basis: 80%;
}

.scan-demo-row .demo-content-text .demo-head {
  font-weight: 900;
  font-size: 45px;
  line-height: 64px;
  margin-bottom: 20px;
  font-family: 'Segoe UI Bold', 'Segoe UI Regular', Tahoma, Geneva, Verdana, sans-serif;
}

.scan-demo-row .demo-content-text .demo-subhead {
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 50px;
}

.scan-demo-row .demo-content-text .button-primary{
  background: #fc5e02;
  border-radius: 4px;
  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.07);
  padding: 20px;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  text-align: center;
  width: 170px;
}

.section-netcore-blog .product-mobile-view {
    display: none;
}
</style>